module.exports = "<span data-ng-message=required>*required, at least one team display column selected</span> ";